import React, {
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Skeleton from "@material-ui/lab/Skeleton";

import api from "../../services/api";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import { contactPhone, contactDisplayName, contactPhoneLabel, unresolvedWhatsAppContact, contactIdentityReview } from "../../helpers/contactIdentity";
import { v4 as uuidv4 } from "uuid";

import { ArrowDropDown, Backup, ContactPhone } from "@material-ui/icons";
import { Menu, MenuItem, Tooltip } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import useContactAgenda from "../../hooks/useContactAgenda";
import ContactAgendaReview from "../../components/ContactAgendaReview";
import ContactAgendaEnrich from "../../components/ContactAgendaEnrich";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

// ================= GEO / DDD CONFIG DO MAPA =================

const geoUrl =
  "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const markers = [
  { markerOffset: -30, name: "Aracaju", coordinates: [-37.0717, -10.9472] },
  { markerOffset: 15, name: "Belém", coordinates: [-48.4878, -1.4558] },
  { markerOffset: 15, name: "Belo Horizonte", coordinates: [-43.9378, -19.8157] },
  { markerOffset: 15, name: "Boa Vista", coordinates: [-60.6739, 2.8195] },
  { markerOffset: 15, name: "Brasília", coordinates: [-47.8825, -15.7942] },
  { markerOffset: 15, name: "Campo Grande", coordinates: [-54.6464, -20.4428] },
  { markerOffset: 15, name: "Cuiabá", coordinates: [-56.0969, -15.6011] },
  { markerOffset: 15, name: "Curitiba", coordinates: [-49.2736, -25.4296] },
  { markerOffset: 15, name: "Florianópolis", coordinates: [-48.5492, -27.5969] },
  { markerOffset: 15, name: "Fortaleza", coordinates: [-38.5267, -3.71839] },
  { markerOffset: 15, name: "Goiânia", coordinates: [-49.2736, -16.6869] },
  { markerOffset: 15, name: "João Pessoa", coordinates: [-34.8631, -7.1195] },
  { markerOffset: 15, name: "Macapá", coordinates: [-51.0667, 0.0333] },
  { markerOffset: 15, name: "Maceió", coordinates: [-35.7353, -9.6658] },
  { markerOffset: 15, name: "Manaus", coordinates: [-60.025, -3.10194] },
  { markerOffset: 15, name: "Natal", coordinates: [-35.2094, -5.795] },
  { markerOffset: 15, name: "Palmas", coordinates: [-48.3347, -10.1844] },
  { markerOffset: 15, name: "Porto Alegre", coordinates: [-51.23, -30.0331] },
  { markerOffset: 15, name: "Porto Velho", coordinates: [-63.9039, -8.7619] },
  { markerOffset: 15, name: "Recife", coordinates: [-34.8811, -8.05389] },
  { markerOffset: 15, name: "Rio Branco", coordinates: [-67.8099, -9.9747] },
  { markerOffset: 15, name: "Rio de Janeiro", coordinates: [-43.1729, -22.9068] },
  { markerOffset: 15, name: "Salvador", coordinates: [-38.4813, -12.9716] },
  { markerOffset: 15, name: "São Luís", coordinates: [-44.3028, -2.5283] },
  { markerOffset: 15, name: "São Paulo", coordinates: [-46.6333, -23.5505] },
  { markerOffset: 15, name: "Teresina", coordinates: [-42.8039, -5.0892] },
  { markerOffset: 15, name: "Vitória", coordinates: [-40.3378, -20.3194] },
];

const dddList = {
  "11": "São Paulo",
  "12": "São Paulo",
  "13": "São Paulo",
  "14": "São Paulo",
  "15": "São Paulo",
  "16": "São Paulo",
  "17": "São Paulo",
  "18": "São Paulo",
  "19": "São Paulo",
  "21": "Rio de Janeiro",
  "22": "Rio de Janeiro",
  "24": "Rio de Janeiro",
  "27": "Espírito Santo",
  "28": "Espírito Santo",
  "31": "Minas Gerais",
  "32": "Minas Gerais",
  "33": "Minas Gerais",
  "34": "Minas Gerais",
  "35": "Minas Gerais",
  "37": "Minas Gerais",
  "38": "Minas Gerais",
  "41": "Paraná",
  "42": "Paraná",
  "43": "Paraná",
  "44": "Paraná",
  "45": "Paraná",
  "46": "Paraná",
  "47": "Santa Catarina",
  "48": "Santa Catarina",
  "49": "Santa Catarina",
  "51": "Rio Grande do Sul",
  "53": "Rio Grande do Sul",
  "54": "Rio Grande do Sul",
  "55": "Rio Grande do Sul",
  "61": "Distrito Federal/Goiás",
  "62": "Goiás",
  "63": "Tocantins",
  "64": "Goiás",
  "65": "Mato Grosso",
  "66": "Mato Grosso",
  "67": "Mato Grosso do Sul",
  "68": "Acre",
  "69": "Rondônia",
  "71": "Bahia",
  "73": "Bahia",
  "74": "Bahia",
  "75": "Bahia",
  "77": "Bahia",
  "79": "Sergipe",
  "81": "Pernambuco",
  "82": "Alagoas",
  "83": "Paraíba",
  "84": "Rio Grande do Norte",
  "85": "Ceará",
  "86": "Piauí",
  "87": "Pernambuco",
  "88": "Ceará",
  "89": "Piauí",
  "91": "Pará",
  "92": "Amazonas",
  "93": "Pará",
  "94": "Pará",
  "95": "Roraima",
  "96": "Amapá",
  "97": "Amazonas",
  "98": "Maranhão",
  "99": "Maranhão",
};

// ================= REDUCER =================

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    height: "calc(100% - 48px)",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      height: "auto",
      minHeight: "calc(100% - 48px)",
      overflowY: "auto",
    },
  },
  pageHeader: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 16,
    color: theme.mode === "light" ? "#1e2a44" : theme.palette.text.primary,
    background: theme.mode === "light"
      ? "#EDF4FF"
      : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
    border: theme.mode === "light" ? "none" : `1px solid ${theme.palette.divider}`,
    boxShadow: theme.mode === "light"
      ? "0 8px 20px rgba(15, 23, 42, 0.06)"
      : "0 8px 20px rgba(0, 0, 0, 0.35)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
  },
  pageHeaderTitle: {
    fontWeight: 600,
    letterSpacing: 0.1,
    fontSize: "1.2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05rem",
    },
  },
  pageHeaderSubtitle: {
    marginTop: theme.spacing(0.25),
    color: theme.mode === "light" ? "rgba(30,42,68,0.78)" : theme.palette.text.secondary,
    fontSize: "0.8rem",
    lineHeight: 1.35,
  },
  headerChip: {
    backgroundColor: theme.mode === "light" ? "#EAF1FF" : "rgba(56, 189, 248, 0.12)",
    color: theme.mode === "light" ? "#2f4b7c" : theme.palette.text.primary,
    border: theme.mode === "light" ? "1px solid #d7e5ff" : `1px solid ${theme.palette.divider}`,
    fontWeight: 500,
    fontSize: "0.72rem",
    height: 24,
  },
  controlsPaper: {
    marginBottom: theme.spacing(2),
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.08)",
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.default,
    },
    "& .MuiInputBase-input": {
      fontSize: "0.82rem",
      paddingTop: 13,
      paddingBottom: 13,
    },
  },
  actionButton: {
    minHeight: 42,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "0.75rem",
    padding: theme.spacing(0.8, 1.4),
    boxShadow: "0 6px 14px rgba(7, 64, 171, 0.14)",
  },
  tabsWrap: {
    marginBottom: theme.spacing(1.5),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    minHeight: 40,
    "& .MuiTab-root": {
      minHeight: 40,
      fontSize: "0.78rem",
      fontWeight: 600,
      textTransform: "none",
    },
  },
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "auto",
    ...theme.scrollbarStyles,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
    [theme.breakpoints.down("sm")]: {
      flex: "0 0 auto",
      padding: theme.spacing(0.75),
    },
  },
  // ESTILOS PARA A ABA MAPA
  legendContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginBottom: "20px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    margin: "5px 10px",
  },
  legendColor: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "5px",
    backgroundColor: "#FFA500",
  },
  totalContactsBar: {
    backgroundColor: theme.palette.primary.main, // usa cor primária do whitelabel
    padding: "10px",
    textAlign: "center",
    color: "white",
    marginBottom: "20px",
    borderRadius: "4px",
  },
  legendCard: {
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: theme.mode === "light" ? "#e8e8e8" : theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: theme.mode === "light" ? "none" : `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    boxShadow: "none",
  },

  // ESTILO DOS CARDS DE CONTATO (MODELO DA SUA PRINT)
  contactCard: {
    backgroundColor:
      theme.mode === "light" ? "#e7edf3" : theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  cardHeader: {
    display: "flex",
    minWidth: 0,
    flex: 1,
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  cardAvatar: {
    marginRight: theme.spacing(2),
    width: 48,
    height: 48,
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 40,
      marginRight: theme.spacing(1.25),
    },
  },
  cardNumber: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    wordBreak: "break-word",
  },
  identityChip: {
    maxWidth: "100%",
    height: "auto",
    "& .MuiChip-label": {
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      paddingTop: 3,
      paddingBottom: 3,
    },
  },
  cardName: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    wordBreak: "break-word",
  },
  cardLabel: {
    fontSize: "0.8rem",
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  cardFooter: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1.25),
      alignItems: "flex-start",
      flexDirection: "column",
    },
  },
  actionsRight: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  actionBtnWhats: {
    backgroundColor: "#25D366",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1ebe5b",
    },
  },
  actionBtnEdit: {
    backgroundColor: "#2196f3",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1976d2",
    },
  },
  actionBtnBlock: {
    backgroundColor: "#ff9800",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#fb8c00",
    },
  },
  actionBtnDelete: {
    backgroundColor: "#f44336",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#e53935",
    },
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();

  const { user, socket } = useContext(AuthContext);



  const [searchParam, setSearchParam] = useState("");

  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);

  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);

  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [filters, setFilters] = useState({ ownerId: "", whatsappId: "", queueId: "", identityStatus: "all" });
  const [enrichOpen, setEnrichOpen] = useState(false);
  const { contacts, totalCount, dispatch, setPageNumber, loading, setLoading, hasMore, options, refresh } =
    useContactAgenda({ user, socket, searchParam, selectedTags, filters });
  const { setCurrentTicket } = useContext(TicketsContext);


  // SELEÇÃO EM MASSA
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [confirmDeleteManyOpen, setConfirmDeleteManyOpen] = useState(false);

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  // CONTROLE DE ABAS (CONTATOS / MAPA)
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);
      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    setSelectedContactIds([]);
    setIsSelectAllChecked(false);
  }, [searchParam, selectedTags, filters, user.companyId, user.id]);
  useEffect(() => {
    const ids = new Set(contacts.map(contact => contact.id));
    setSelectedContactIds(previous => previous.filter(id => ids.has(id)));
  }, [contacts]);
  useEffect(() => {
    if (!options.canReview && tabValue === 2) setTabValue(0);
  }, [options.canReview, tabValue]);
  useEffect(() => {
    if (options.restricted && filters.ownerId && !["mine", String(user.id)].includes(filters.ownerId)) {
      setFilters(previous => ({ ...previous, ownerId: "mine" }));
    }
  }, [options.restricted, filters.ownerId, user.id]);
  useEffect(() => {
    setFilters({ ownerId: "", whatsappId: "", queueId: "", identityStatus: "all" });
  }, [user.companyId, user.id]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
  };

  const handleToggleSelectContact = (contactId) => (event) => {
    if (event.target.checked) {
      setSelectedContactIds((prevSelected) => [...prevSelected, contactId]);
    } else {
      setSelectedContactIds((prevSelected) =>
        prevSelected.filter((id) => id !== contactId)
      );
      setIsSelectAllChecked(false);
    }
  };

  const handleSelectAllContacts = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      const allContactIds = contacts.map((contact) => contact.id);
      setSelectedContactIds(allContactIds);
    } else {
      setSelectedContactIds([]);
    }
  };

  const handleDeleteSelectedContacts = async () => {
    try {
      setLoading(true);
      await api.delete("/contacts/batch-delete", {
        data: { contactIds: selectedContactIds },
      });
      toast.success("Contatos selecionados deletados com sucesso!");
      setSelectedContactIds([]);
      setIsSelectAllChecked(false);
      setConfirmDeleteManyOpen(false);
      dispatch({ type: "RESET" });
      setPageNumber(1);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...blockingContact, active: false },
      });
      toast.success("Contato bloqueado");
    } catch (err) {
      toastError(err);
    }
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...unBlockingContact, active: true },
      });
      toast.success("Contato desbloqueado");
    } catch (err) {
      toastError(err);
    }
    setUnBlockingContact(null);
  };

  const handleimportContact = async (whatsappId) => {
    setImportContactModalOpen(false);

    try {
      await api.post("/contacts/import", { whatsappId });
      history.go(0);
      setImportContactModalOpen(false);
    } catch (err) {
      toastError(err);
      setImportContactModalOpen(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (tabValue !== 0 || !hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  // ===== FUNÇÃO PARA CONTAR CONTATOS POR ESTADO (USADA NO MAPA) =====
  const countContactsByState = () => {
    const stateCounts = {};

    contacts.forEach((contact) => {
      const number = contactPhone(contact);
      if (number && number.length > 4) {
        const ddd = number.substring(2, 4);
        if (number.startsWith("55") && dddList[ddd]) {
          const state = dddList[ddd];
          if (!stateCounts[state]) {
            stateCounts[state] = 0;
          }
          stateCounts[state]++;
        } else {
          if (!stateCounts["Outros"]) {
            stateCounts["Outros"] = 0;
          }
          stateCounts["Outros"]++;
        }
      }
    });

    return stateCounts;
  };

  const stateCounts = countContactsByState();

  return (
    <div className={classes.pageRoot}>
      <ContactAgendaEnrich open={enrichOpen} onClose={() => setEnrichOpen(false)} connections={options.connections} onDone={refresh} />
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        onSave={(contact) =>
          dispatch({ type: "UPDATE_CONTACTS", payload: contact })
        }
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>

      <ConfirmationModal
        title={
          deletingContact
            ? `${options.canReview ? "Excluir da empresa" : "Remover da minha agenda"}: ${contactDisplayName(deletingContact)}?`
            : blockingContact
            ? `Bloquear Contato ${blockingContact.name}?`
            : unBlockingContact
            ? `Desbloquear Contato ${unBlockingContact.name}?`
            : ImportContacts
            ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
            : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
        }
        isCellPhone={ImportContacts}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={(e) =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : blockingContact
            ? handleBlockContact(blockingContact.id)
            : unBlockingContact
            ? handleUnBlockContact(unBlockingContact.id)
            : ImportContacts
            ? handleimportContact(e)
            : handleImportExcel()
        }
      >
        {exportContact
          ? `${i18n.t("contacts.confirmationModal.exportContact")}`
          : deletingContact
          ? options.canReview ? `${i18n.t("contacts.confirmationModal.deleteMessage")}` : "O cadastro compartilhado e os históricos serão preservados."
          : blockingContact
          ? `${i18n.t("contacts.confirmationModal.blockContact")}`
          : unBlockingContact
          ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
          : ImportContacts
          ? `Escolha de qual conexão deseja importar`
          : `${i18n.t(
              "contactListItems.confirmationModal.importMessage"
            )}`}
      </ConfirmationModal>

      <ConfirmationModal
        title={`${options.canReview ? "Excluir da empresa" : "Remover da minha agenda"}: ${selectedContactIds.length} contatos?`}
        open={confirmDeleteManyOpen}
        onClose={() => setConfirmDeleteManyOpen(false)}
        onConfirm={handleDeleteSelectedContacts}
      >
        {options.canReview ? "Essa ação é irreversível." : "O cadastro compartilhado e os históricos serão preservados."}
      </ConfirmationModal>

      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      <MainHeader>
        <Grid container style={{ width: "100%" }}>
          <Grid item xs={12}>
            <Paper elevation={0} className={classes.pageHeader}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={8}>
                  <Typography className={classes.pageHeaderTitle}>
                    {i18n.t("contacts.title")}
                  </Typography>
                  <Typography className={classes.pageHeaderSubtitle}>
                    Gerencie sua base de contatos com ações rápidas e visão operacional.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4} style={{ textAlign: "right" }}>
                  <Chip
                    icon={<ContactPhone style={{ color: "#2f4b7c", fontSize: 14 }} />}
                    label={`${totalCount} contatos`}
                    className={classes.headerChip}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper elevation={0} className={classes.controlsPaper}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                  <TagsFilter onFiltered={handleSelectedTags} />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    placeholder={i18n.t("contacts.searchPlaceholder")}
                    type="search"
                    value={searchParam}
                    onChange={handleSearch}
                    variant="outlined"
                    className={classes.searchField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="secondary" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <PopupState variant="popover" popupId="demo-popup-menu">
                    {(popupState) => (
                      <React.Fragment>
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.actionButton}
                          {...bindTrigger(popupState)}
                        >
                          Importar/Exportar
                          <ArrowDropDown />
                        </Button>
                        <Menu {...bindMenu(popupState)}>
                          <MenuItem
                            onClick={() => {
                              setConfirmOpen(true);
                              setImportContacts(true);
                              popupState.close();
                            }}
                          >
                            <ContactPhone
                              fontSize="small"
                              color="primary"
                              style={{
                                marginRight: 10,
                              }}
                            />
                            {i18n.t("contacts.menu.importYourPhone")}
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setImportContactModalOpen(true);
                            }}
                          >
                            <Backup
                              fontSize="small"
                              color="primary"
                              style={{
                                marginRight: 10,
                              }}
                            />
                            {i18n.t("contacts.menu.importToExcel")}
                          </MenuItem>
                        </Menu>
                      </React.Fragment>
                    )}
                  </PopupState>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => setConfirmDeleteManyOpen(true)}
                    disabled={selectedContactIds.length === 0 || loading}
                    color="primary"
                    className={classes.actionButton}
                  >
                    {options.canReview ? "Excluir" : "Remover"} ({selectedContactIds.length})
                  </Button>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleOpenContactModal}
                    className={classes.actionButton}
                  >
                    {i18n.t("contacts.buttons.add")}
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: 8 }}>
                {[
                  ["ownerId", "Responsável", options.owners, "Todos", <MenuItem key="mine" value="mine">Meus contatos</MenuItem>],
                  ["whatsappId", "Conexão", options.connections, "Todas", null],
                  ["queueId", "Fila", options.queues, "Todas", null],
                  ["identityStatus", "Identificação", [{ id: "identified", name: "Telefone identificado" }, { id: "pending", name: "Identificação pendente" }, { id: "review", name: "Cadastro em revisão" }, { id: "linked", name: "Vínculo revisado" }], "Todas", null],
                ].map(([key, label, values, allLabel, extra]) => <Grid item xs={12} sm={6} md={3} key={key}>
                  <TextField select fullWidth variant="outlined" size="small" label={label} value={filters[key]} onChange={event => setFilters(previous => ({ ...previous, [key]: event.target.value }))}>
                    <MenuItem value={key === "identityStatus" ? "all" : ""}>{allLabel}</MenuItem>
                    {extra}{values.map(item => <MenuItem key={item.id} value={String(item.id)}>{item.name}</MenuItem>)}
                  </TextField>
                </Grid>)}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </MainHeader>

      {importContactModalOpen && (
        <ContactImportWpModal
          isOpen={importContactModalOpen}
          handleClose={() => setImportContactModalOpen(false)}
          selectedTags={selectedTags}
          hideNum={hideNum}
          userProfile={user.profile}
        />
      )}

      {/* ABAS CONTATOS / MAPA */}
      <Paper elevation={0} className={classes.tabsWrap}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="abas-contatos-mapa"
          className={classes.tabsRoot}
        >
          <Tab label="Contatos" />
          <Tab label={`Mapa (${contacts.length})`} />
          {options.canReview && <Tab label="Revisões" />}
        </Tabs>
      </Paper>

      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <>
          <input
            style={{ display: "none" }}
            id="upload"
            name="file"
            type="file"
            accept=".xls,.xlsx"
            onChange={() => {
              setConfirmOpen(true);
            }}
            ref={fileUploadRef}
          />
        </>

        {/* ABA CONTATOS EM CARDS */}
        {tabValue === 0 && (
          <Box p={2}>
            {!loading && !contacts.length && <Typography variant="body2" style={{ marginBottom: 16 }}>Nenhum contato encontrado.</Typography>}
            {/* checkbox global "selecionar todos" */}
            <Box display="flex" alignItems="center" mb={2}>
              <Checkbox
                checked={isSelectAllChecked}
                onChange={handleSelectAllContacts}
                inputProps={{ "aria-label": "Selecionar todos os contatos" }}
              />
              <Typography variant="body2">
                Selecionar todos os contatos
              </Typography>
              <Typography variant="caption" style={{ marginLeft: 12 }}>{contacts.length} de {totalCount}</Typography>
              {options.canReview && <Tooltip title="Atualizar identificação"><IconButton aria-label="Atualizar identificação" onClick={() => setEnrichOpen(true)}><Sync /></IconButton></Tooltip>}
            </Box>

            <Grid container spacing={2}>
              {contacts.map((contact) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={contact.id}>
                  <Card className={classes.contactCard}>
                    <CardContent>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Box className={classes.cardHeader}>
                          <Avatar
                            src={`${contact?.urlPicture}`}
                            className={classes.cardAvatar}
                          />
                          <Box minWidth={0} flex={1}>
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              className={classes.cardName}
                            >
                              {contactDisplayName(contact)}
                            </Typography>
                            <Typography
                              variant="body2"
                              className={classes.cardNumber}
                            >
                              {contactPhoneLabel(contact, formatSerializedId, enableLGPD && hideNum && user.profile === "user")}
                            </Typography>
                            {unresolvedWhatsAppContact(contact) && (
                              <Chip className={classes.identityChip} size="small" variant="outlined" label="Identificação pendente" />
                            )}
                            {contactIdentityReview(contact) && (
                              <Chip className={classes.identityChip} size="small" variant="outlined" label="Cadastro em revisão" />
                            )}
                            {contact.identityReviewStatus === "linked" && <Chip className={classes.identityChip} size="small" variant="outlined" label="Vínculo revisado" />}
                            {contact.personalAgenda && <Chip className={classes.identityChip} size="small" variant="outlined" label="Minha agenda" />}
                            {contact.email && (
                              <Typography
                                variant="body2"
                                className={classes.cardNumber}
                              >
                                {contact.email}
                              </Typography>
                            )}
                            {contact?.whatsapp?.name && (
                              <Typography
                                variant="body2"
                                className={classes.cardNumber}
                              >
                                Conexão: {contact?.whatsapp?.name}
                              </Typography>
                            )}
                            <Typography
                              variant="body2"
                              className={classes.cardLabel}
                            >
                              Status:{" "}
                              {contact.active ? (
                                <CheckCircleIcon
                                  style={{ color: "green", fontSize: 16 }}
                                />
                              ) : (
                                <CancelIcon
                                  style={{ color: "red", fontSize: 16 }}
                                />
                              )}
                            </Typography>
                          </Box>
                        </Box>

                        <Checkbox
                          checked={selectedContactIds.includes(contact.id)}
                          onChange={handleToggleSelectContact(contact.id)}
                          inputProps={{
                            "aria-label": `Selecionar contato ${contactDisplayName(contact)}`,
                          }}
                        />
                      </Box>

                      <Box className={classes.cardFooter}>
                        <Box>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                          >
                            WhatsApp:
                          </Typography>
                        </Box>
                        <Box className={classes.actionsRight}>
                          <IconButton
                            size="small"
                            className={classes.actionBtnWhats}
                            disabled={!contact.active}
                            onClick={() => {
                              setContactTicket(contact);
                              setNewTicketModalOpen(true);
                            }}
                          >
                            {contact.channel === "whatsapp" && <WhatsApp />}
                            {contact.channel === "instagram" && <Instagram />}
                            {contact.channel === "facebook" && <Facebook />}
                          </IconButton>

                          <IconButton
                            size="small"
                            className={classes.actionBtnEdit}
                            onClick={() => hadleEditContact(contact.id)}
                          >
                            <EditIcon style={{ fontSize: 18 }} />
                          </IconButton>

                          <IconButton
                            size="small"
                            className={classes.actionBtnBlock}
                            onClick={
                              contact.active
                                ? () => {
                                    setConfirmOpen(true);
                                    setBlockingContact(contact);
                                  }
                                : () => {
                                    setConfirmOpen(true);
                                    setUnBlockingContact(contact);
                                  }
                            }
                          >
                            {contact.active ? (
                              <BlockIcon style={{ fontSize: 18 }} />
                            ) : (
                              <CheckCircleIcon style={{ fontSize: 18 }} />
                            )}
                          </IconButton>

                          <Tooltip title={options.canReview ? "Excluir contato da empresa" : "Remover da minha agenda"}>
                              <IconButton
                                size="small"
                                className={classes.actionBtnDelete}
                                onClick={(e) => {
                                  setConfirmOpen(true);
                                  setDeletingContact(contact);
                                }}
                              >
                                <DeleteOutlineIcon style={{ fontSize: 18 }} />
                              </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            {loading && (
              <Box mt={2}>
                <Grid container spacing={2}>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={`contacts-skeleton-${index}`}>
                      <Card className={classes.contactCard}>
                        <CardContent>
                          <Box display="flex" alignItems="center" mb={1.5}>
                            <Skeleton variant="circle" width={40} height={40} />
                            <Box ml={1.5} flex={1}>
                              <Skeleton variant="text" width="70%" height={22} />
                              <Skeleton variant="text" width="45%" height={18} />
                            </Box>
                          </Box>
                          <Skeleton variant="rect" height={36} />
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        )}

        {/* ABA MAPA */}
        {tabValue === 2 && options.canReview && <ContactAgendaReview connection={filters.whatsappId} socket={socket} companyId={user.companyId} />}
        {tabValue === 1 && (
          <>
            <Box className={classes.totalContactsBar}>
              <Typography variant="h6">
                Total de Contatos por Estado: {contacts.length}
              </Typography>
            </Box>

            <Box p={3}>
              <Card className={classes.legendCard}>
                <CardContent>
                  <Box className={classes.legendContainer}>
                    {Object.entries(stateCounts).map(([state, count]) => (
                      <Box key={state} className={classes.legendItem}>
                        <div className={classes.legendColor} />
                        <Typography variant="body2">
                          {state}: {count} contato(s)
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>

              <ComposableMap
                projection="geoMercator"
                projectionConfig={{
                  scale: 600,
                  center: [-53, -15],
                }}
                style={{ width: "100%", height: "auto" }}
              >
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) => {
                      const state = geo.properties.name;
                      const count = stateCounts[state] || 0;

                      return (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill={count > 0 ? "#FFA500" : "#EAEAEC"}
                          stroke="#D6D6DA"
                          style={{
                            hover: {
                              fill: "#FFA500",
                              stroke: "#D6D6DA",
                            },
                          }}
                        />
                      );
                    })
                  }
                </Geographies>
                {markers.map(({ name, coordinates, markerOffset }) => (
                  <Marker key={name} coordinates={coordinates}>
                    <circle
                      r={5}
                      fill="#F00"
                      stroke="#fff"
                      strokeWidth={1}
                    />
                    <text
                      textAnchor="middle"
                      y={markerOffset}
                      style={{
                        fontFamily: "system-ui",
                        fill: "#5D5A6D",
                        fontSize: "12px",
                      }}
                    >
                      {name}
                    </text>
                  </Marker>
                ))}
              </ComposableMap>
            </Box>
          </>
        )}
      </Paper>
    </div>
  );
};

export default Contacts;
